import { useEffect, useMemo, useState } from 'react';
import { fetchPublicLeaderboard } from '../lib/callables';
import { averageAnswerMs } from '../lib/team-performance';
import type { ArenaEvent, TeamPublic } from '../types/arena';

interface PublicLeaderboardPayload {
  event: ArenaEvent | null;
  teams: TeamPublic[];
  serverTimeMs?: number;
}

export function usePublicLeaderboardData(enabled = false) {
  const [event, setEvent] = useState<ArenaEvent | null>(null);
  const [teams, setTeams] = useState<TeamPublic[]>([]);
  const [serverTimeMs, setServerTimeMs] = useState<number | null>(null);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    if (!enabled) return;
    let alive = true;
    const refresh = async () => {
      try {
        const payload = await fetchPublicLeaderboard<PublicLeaderboardPayload>();
        if (!alive) return;
        setEvent(payload.event);
        setTeams(payload.teams ?? []);
        setServerTimeMs(payload.serverTimeMs ?? Date.now());
        setError(null);
      } catch (reason) {
        if (alive) setError(reason instanceof Error ? reason.message : 'جدول رتبه‌بندی دریافت نشد.');
      }
    };
    void refresh();
    const interval = window.setInterval(() => void refresh(), 1000);
    return () => {
      alive = false;
      window.clearInterval(interval);
    };
  }, [enabled]);

  const rankedTeams = useMemo(
    () =>
      [...teams].sort(
        (a, b) => b.score - a.score || b.correctCount - a.correctCount || b.hardCorrect - a.hardCorrect || averageAnswerMs(a) - averageAnswerMs(b) || a.name.localeCompare(b.name, 'fa'),
      ),
    [teams],
  );

  return { event, teams: rankedTeams, serverTimeMs, error };
}
